









































import { Component, Vue, Ref } from "vue-property-decorator";

@Component({
    components: {
        FormBase: () => import("../forms/Base.vue"),
        FormInput: () => import("../forms/Input.vue"),
        ElSelect: () => import("../forms/select.vue"),
        ElPriceSelect: () => import("../forms/price-select.vue")
    }
})
export default class EstateSearchForm extends Vue {
    @Ref() readonly estateSearchForm!: FormClass;

    payload: any = {
        cities: "",
        region: "",
        type: "",
        sale_or_let: "",
        price: {
            min: "",
            max: ""
        },
        extra_info: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: ""
    };

    typeOptions: SelectOption[] = [
        { id: 1, value: "house", label: "Woning" },
        { id: 2, value: "apartment", label: "Appartement" },
        { id: 3, value: "parking", label: "Parking" },
        { id: 4, value: "land", label: "Grond" },
        { id: 5, value: "office", label: "Kantoor" }
    ];

    saleOrLetOptions: SelectOption[] = [
        { id: 1, value: "sale", label: "Kopen" },
        { id: 2, value: "let", label: "Huren" }
    ];

    cityOptions: SelectOption[] = [];

    private async getCities() {
        // @ts-ignore
        return axios.get("/api/all-zips").then((response: any) => {
            const ziplist = response.data;

            // @ts-ignore
            this.cityOptions = [];

            Object.keys(ziplist).forEach((index: string) => {
                let match: any = ziplist[index];
                let option: any = {
                    id: `${match.city} - ${match.zip}`,
                    label: `${match.city}`,
                    tagLabel: `${match.city} (${match.zip})`,
                    selectedLabel: `<span class='flex flex-row items-center gap-[4px]'><span>${match.city}</span><small class='text-red'>${match.zip}</small></span>`,
                    value: `${match.city} - ${match.zip}`
                };

                if (match.children) {
                    option.children = [];
                    match.children.forEach((childList: any) => {
                        option.children.push({
                            id: `${childList.city} - ${childList.zip}`,
                            parent_id: match.zip,
                            label: `${childList.city} ${childList.zip}`,
                            tagLabel: `${childList.city} (${match.zip})`,
                            indent: true,
                            selectedLabel: `<span class='flex flex-row items-center gap-[4px] ml-16'><span>${childList.city}</span><small class='text-red'>${childList.zip}</small></span>`,
                            value: `${childList.city} - ${childList.zip}`
                        });
                    });

                    option.children.sort((a: any, b: any) => {
                        return a.label.localeCompare(b.label);
                    });
                }

                this.cityOptions.push(option);
            });

            this.cityOptions.sort((a: any, b: any) => {
                return a.label.localeCompare(b.label);
            });
        });
    }

    get minPriceAllowed() {
        if (this.payload.sale_or_let === "sale") {
            return 1000;
        }

        return 500;
    }

    mounted() {
        this.getCities();
    }

    private calculateCleanZips() {
        if (!this.payload.cities) {
            return "";
        }

        let cleanZips: any = this.payload.cities.split(",").map((zip: string) => zip.split(" - ")[1]);

        //@ts-ignore
        this.payload.region = cleanZips.filter((v, i, a) => a.indexOf(v) === i).join(",");
    }

    private submitForm() {
        this.calculateCleanZips();

        // @ts-ignore
        axios
            .post("/api/forms/estate-search", this.payload)
            .then((response: any) => {
                this.estateSearchForm.handleSuccess();
                this.payload = {
                    cities: "",
                    region: "",
                    type: "",
                    sale_or_let: "",
                    price: {
                        min: "",
                        max: ""
                    },
                    extra_info: "",
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: ""
                };

                this.estateSearchForm.reset();
            })
            .catch((e: any) => {
                console.log(e);

                if (e.response && e.response.data) {
                    this.estateSearchForm.handleErrors(e.response.data);
                }
            });
    }
}
